import { render, staticRenderFns } from "./MediaLibraryPicker.vue?vue&type=template&id=10b98a26&scoped=true&"
import script from "./MediaLibraryPicker.vue?vue&type=script&lang=js&"
export * from "./MediaLibraryPicker.vue?vue&type=script&lang=js&"
import style0 from "./MediaLibraryPicker.vue?vue&type=style&index=0&id=10b98a26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b98a26",
  null
  
)

export default component.exports